import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import type { TradeDetailsTabsVariant } from "@/components/custom/trade-details-tabs";

const categoryValues: [TradeDetailsTabsVariant, ...TradeDetailsTabsVariant[]] =
  ["block", "allocation", "message"];

const categoryEnum = z.enum(categoryValues);

const pairOffReviewSearchSchema = z.object({
  sysId: z.coerce.number(),
  wiid: z.coerce.number(),
  ticketType: z.string(),
  category: categoryEnum,
});

export type PairOffReviewSearch = z.infer<typeof pairOffReviewSearchSchema>;

export const Route = createFileRoute("/pair-off-review")({
  validateSearch: pairOffReviewSearchSchema,
  staticData: { breadcrumb: "Pair Off Review" },
});
